import {
  useEffect,
  useState,
  useCallback,
} from "react";

import {
  getRegions,
  getDistricts,
} from "../../api/region";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  createClinic,
  updateClinic,
  getAdminClinicDetail,
  resetClinicPassword,
} from "../../api/clinics";

import {
  setSelectedClinic,
} from "../../store/selectedClinicStore";

import { getLang } from "../../store/uiStore";
import "./ClinicForm.css";


export default function ClinicFormPage() {

  const navigate = useNavigate();

  const { clinicId } = useParams();

  const isEdit = Boolean(clinicId);

  const lang = getLang();

  const tr = {
    editTitle: lang === "ru" ? "Редактирование клиники" : "Таҳрири муассиса",
    createTitle: lang === "ru" ? "Создание клиники" : "Таъсиси муассиса",
    editSaved: lang === "ru" ? "{tr.editSaved}" : "✓ Тағйирот бомуваффақият сабт шуд",
    openPassport: lang === "ru" ? "Открыть паспорт" : "Кушодани шиноснома",
    backToList: lang === "ru" ? "Вернуться к списку" : "Бозгаштан ба рӯйхат",
    backToClinics: lang === "ru" ? "Вернуться к списку клиник" : "Бозгаштан ба рӯйхати муассисаҳо",
    clinicCreated: lang === "ru" ? "✓ Клиника успешно создана" : "✓ Муассиса бомуваффақият таъсис дода шуд",
    saveCredentials: lang === "ru"
      ? "⚠ Сохраните логин и пароль. После закрытия страницы пароль больше не будет доступен."
      : "⚠ Логин ва паролро нигоҳ доред. Пас аз бастани саҳифа парол дигар дастрас нахоҳад буд.",
    login: lang === "ru" ? "Логин:" : "Логин:",
    password: lang === "ru" ? "Пароль:" : "Парол:",
    newPassword: lang === "ru" ? "Новый пароль:" : "Пароли нав:",
    copy: lang === "ru" ? "Скопировать" : "Нусхабардорӣ кардан",
    newPasswordCreated: lang === "ru" ? "{tr.newPasswordCreated}" : "✓ Пароли нав сохта шуд",
    saveClinic: lang === "ru" ? "Сохранить" : "Сабт кардан",
    clinicSaved: lang === "ru" ? "Клиника сохранена" : "Муассиса сабт шуд",
    saving: lang === "ru" ? "Сохранение..." : "Сабт шуда истодааст...",
    resetPassword: lang === "ru" ? "Сбросить пароль" : "Аз нав танзим кардани парол",
    resetting: lang === "ru" ? "Сброс..." : "Аз нав танзим...",
    mainData: lang === "ru" ? "Основные данные клиники" : "Маълумоти асосии муассиса",
    clinicName: lang === "ru" ? "Название" : "Ном",
    innLabel: lang === "ru" ? "ИНН" : "РМА",
    registrationNumber: lang === "ru" ? "Регистрационный номер" : "Рақами бақайдгирӣ",
    region: lang === "ru" ? "Регион" : "Вилоят",
    selectRegion: lang === "ru" ? "Выберите регион" : "Вилоятро интихоб кунед",
    district: lang === "ru" ? "Район" : "Ноҳия",
    selectDistrict: lang === "ru" ? "Выберите район" : "Ноҳияро интихоб кунед",
    address: lang === "ru" ? "Адрес" : "Суроға",
    email: "Email",
    phone: "Телефон",
    status: lang === "ru" ? "Статус" : "Ҳолат",
    active: lang === "ru" ? "Активна" : "Фаъол",
    suspended: lang === "ru" ? "Приостановлена" : "Боздошта шудааст",
    closed: lang === "ru" ? "Закрыта" : "Баста шудааст",
    legalType: lang === "ru" ? "Юридический тип" : "Навъи ҳуқуқӣ",
    legalEntity: lang === "ru" ? "Юридическое лицо" : "Шахси ҳуқуқӣ",
    individual: lang === "ru" ? "Физическое лицо" : "Шахси воқеӣ",
    clinicType: lang === "ru" ? "Тип учреждения" : "Навъи муассиса",
    multidisciplinary: lang === "ru" ? "Многопрофильный" : "Бисёрсоҳавӣ",
    specialized: lang === "ru" ? "Профильный центр" : "Маркази соҳавӣ",
    laboratory: lang === "ru" ? "Лаборатория" : "Озмоишгоҳ",
    functional: lang === "ru" ? "Функциональная диагностика" : "Ташхиси функсионалӣ",
    dentistry: "Стоматология",
    cosmetology: "Косметология",
    traditional: lang === "ru" ? "Народная медицина" : "Тибби халқӣ",
    other: lang === "ru" ? "Другое" : "Дигар",
    clinicUser: lang === "ru" ? "Пользователь клиники" : "Корбари муассиса",
    username: lang === "ru" ? "Логин пользователя" : "Логини корбар",
    autoGenerated: lang === "ru" ? "Автоматически генерируется" : "Ба таври худкор сохта мешавад",
    usernameHelp: lang === "ru"
      ? "{tr.usernameHelp}"
      : "Агар холӣ гузоред — система логинро дар асоси ИНН ба таври худкор месозад.",
    passwordField: lang === "ru" ? "Пароль" : "Парол",
    passwordHelp: lang === "ru"
      ? "{tr.passwordHelp}"
      : "Агар холӣ гузоред — система пароли бехатарро ба таври худкор месозад.",
    saveError: lang === "ru" ? "Ошибка сохранения" : "Хатои сабт",
    resetError: lang === "ru" ? "Ошибка сброса пароля" : "Хатои аз нав танзим кардани парол",
  };

  const getLocalizedName = (item) =>
    lang === "ru"
      ? (item?.name_ru || item?.name || "")
      : (item?.name_tj || item?.name_ru || item?.name || "");


  const [loading, setLoading] =
    useState(false);

  const [errors, setErrors] =
    useState({});

  const [isDirty, setIsDirty] =
    useState(false);

  const [regions, setRegions] =
    useState([]);

  const [districts, setDistricts] =
    useState([]);

  const [
    generatedCredentials,
    setGeneratedCredentials
  ] = useState(null);

  const [
    createdClinic,
    setCreatedClinic
  ] = useState(null);

  const [
    createSuccess,
    setCreateSuccess
  ] = useState(false);

  const [
    editSuccess,
    setEditSuccess
  ] = useState(false);

  const [isSaved, setIsSaved] =
    useState(false);

  const [
    resetPasswordData,
    setResetPasswordData
  ] = useState(null);

  const [
    resetPasswordLoading,
    setResetPasswordLoading
  ] = useState(false);

  const readOnlyStyle = {

    backgroundColor:
      isSaved
        ? "#f3f4f6"
        : "",

    color:
      isSaved
        ? "#6b7280"
        : "",

    cursor:
      isSaved
        ? "not-allowed"
        : "default",
  };

  const [formData, setFormData] =
    useState({

      name: "",

      registration_number: "",

      inn: "",

      address: "",

      email: "",

      phone: "",

      username: "",

      password: "",

      region: "",

      district: "",

      status: "active",

      legal_type: "legal",

      clinic_type:
        "multidisciplinary",
  });

  const loadClinic = useCallback(
    async () => {

      try {

        setErrors({});

        setLoading(true);

        const response =
          await getAdminClinicDetail(
            clinicId
          );

        setCreatedClinic(
          response.data
        );

        setIsDirty(false);

        setFormData(response.data);

      } catch (error) {

        console.error(error);

      } finally {

        setLoading(false);
      }
    },
    [clinicId]
  );

  const loadRegions = useCallback(
    async () => {

      try {

        const response =
          await getRegions();

        setRegions(response.data);

      } catch (error) {

        console.error(error);
      }
    },
    []
  );

  const loadDistricts = useCallback(
    async (regionId) => {

      if (!regionId) {

        setDistricts([]);

        return;
      }

      try {

        const response =
          await getDistricts(
            regionId
          );

        setDistricts(response.data);

      } catch (error) {

        console.error(error);
      }
    },
    []
  );

  useEffect(() => {

    loadRegions();

  }, [loadRegions]);

  useEffect(() => {

    if (formData.region) {

      loadDistricts(
        formData.region
      );
    }

  }, [
    formData.region,
    loadDistricts,
  ]);

  useEffect(() => {

    if (isEdit) {

      loadClinic();
    }

  }, [isEdit, loadClinic]);


  const handleChange = (e) => {

    setIsDirty(true);

    setFormData({

      ...formData,

      [e.target.name]: e.target.value,
    });
  };


  const handleResetPassword =
    async () => {

      try {

        setResetPasswordLoading(
          true
        );

        const response =
          await resetClinicPassword(
            clinicId
          );

        setResetPasswordData(
          response.data
        );

        window.scrollTo({

          top: 0,

          behavior: "smooth",
        });

      } catch (error) {

        console.error(error);

        alert(tr.resetError);

      } finally {

        setResetPasswordLoading(
          false
        );
      }
    };


  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      if (isEdit) {

        await updateClinic(
          clinicId,
          formData
        );
        setIsDirty(false);

        setEditSuccess(true);

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

      } else {

        const response =
          await createClinic(
            formData
          );


        setCreatedClinic(
          response.data
        );

        setCreateSuccess(true);

        setIsSaved(true);

        setIsDirty(false);

        setGeneratedCredentials({

          username:
            response.data.generated_username,

          password:
            response.data.generated_password,
        });

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

      }

    } catch (error) {

      console.error(error);

      if (
        error.response?.data
      ) {

        setErrors(
          error.response.data
        );

      } else {

        alert(tr.saveError);
      }

    } finally {

      setLoading(false);
    }
  };

  useEffect(() => {

    const handleBeforeUnload = (e) => {

      if (!isDirty) return;

      e.preventDefault();

      e.returnValue = "";
    };

    window.addEventListener(
      "beforeunload",
      handleBeforeUnload
    );

    return () => {

      window.removeEventListener(
        "beforeunload",
        handleBeforeUnload
      );
    };

  }, [isDirty]);

  return (

    <div className="nizom-clinic-form-page">

      <h2>

        {isEdit ? tr.editTitle : tr.createTitle}

      </h2>

      {editSuccess && (

        <div
          style={{
            marginBottom: "20px",
            padding: "12px",
            background: "#dcfce7",
            border: "1px solid #86efac",
            borderRadius: "6px",
            color: "#166534",
            maxWidth: "700px",
          }}
        >

          <h3>
            {tr.editSaved}
          </h3>

          <div
            style={{
              marginTop: "12px",
              display: "flex",
              gap: "12px",
            }}
          >

            <button
              type="button"
              onClick={() => {

                setSelectedClinic({

                  id:
                    createdClinic?.id ||
                    Number(clinicId),

                  name:
                    createdClinic?.name ||
                    formData.name,
                });

                navigate("/passport");
              }}
            >
              {tr.openPassport}
            </button>

            <button
              type="button"
              onClick={() =>
                navigate("/clinics")
              }
            >
              {tr.backToList}
            </button>

          </div>

        </div>

      )}

      {generatedCredentials && (

        <div
          style={{
            marginTop: "24px",
            padding: "20px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            background: "#f5f5f5",
            maxWidth: "700px",
          }}
        >

          <h3
            style={{
              color: "#166534",
              marginBottom: "12px",
            }}
          >
            {tr.clinicCreated}
          </h3>

          <p
            style={{
              color: "#92400e",
              fontWeight: "bold",
            }}
          >

            {tr.saveCredentials}

          </p>

          <div>

            <strong>{tr.login}</strong>

            {" "}

            {generatedCredentials.username}

          </div>

          <div
            style={{
              marginTop: "12px",
            }}
          >

            <strong>{tr.password}</strong>

            {" "}

            {generatedCredentials.password}

          </div>

          <div
            style={{
              marginTop: "20px",
              display: "flex",
              gap: "12px",
            }}
          >

            <button
              type="button"
              onClick={() => {

                navigator.clipboard.writeText(

                  `${tr.login} ${generatedCredentials.username}\n${tr.password} ${generatedCredentials.password}`
                );
              }}
            >
              {tr.copy}
            </button>

            <button
              type="button"
              onClick={() => {

                setSelectedClinic({

                  id: createdClinic?.id || clinicId,

                  name:
                    createdClinic?.name ||
                    formData.name,
                });

                navigate("/passport");
              }}
            >
              {tr.openPassport}
            </button>

            <button
              type="button"
              onClick={() =>
                navigate("/clinics")
              }
            >
              {tr.backToClinics}
            </button>

          </div>

        </div>

      )}


      {resetPasswordData && (

        <div
          style={{

            marginBottom: "24px",

            padding: "20px",

            border:
              "1px solid #86efac",

            borderRadius: "8px",

            background:
              "#dcfce7",

            maxWidth: "700px",
          }}
        >

          <h3
            style={{
              color: "#166534",
            }}
          >

            {tr.newPasswordCreated}

          </h3>

          <div>

            <strong>{tr.login}</strong>

            {" "}

            {
              resetPasswordData.username
            }

          </div>

          <div
            style={{
              marginTop: "12px",
            }}
          >

            <strong>{tr.newPassword}</strong>

            {" "}

            {
              resetPasswordData.password
            }

          </div>

          <div
            style={{
              marginTop: "20px",
            }}
          >

            <button
              type="button"

              onClick={() => {

                const text =

      `${tr.login} ${resetPasswordData.username}\n${tr.password} ${resetPasswordData.password}`;

                if (
                  navigator.clipboard &&
                  window.isSecureContext
                ) {

                  navigator.clipboard
                    .writeText(text);

                } else {

                  const textarea =
                    document.createElement(
                      "textarea"
                    );

                  textarea.value =
                    text;

                  document.body
                    .appendChild(
                      textarea
                    );

                  textarea.select();

                  document.execCommand(
                    "copy"
                  );

                  textarea.remove();
                }
              }}
            >

              {tr.copy}

            </button>

          </div>

        </div>

      )}

      {createSuccess &&
       !isEdit &&
       !generatedCredentials && (

        <div
          style={{
            marginBottom: "24px",
            padding: "20px",
            border: "1px solid #86efac",
            borderRadius: "8px",
            background: "#dcfce7",
            maxWidth: "700px",
          }}
        >

          <h3>
            {tr.clinicCreated}
          </h3>

          <div
            style={{
              display: "flex",
              gap: "12px",
              marginTop: "20px",
            }}
          >

            <button
              type="button"
              onClick={() =>
                navigate("/clinics")
              }
            >
              {tr.backToList}
            </button>

            <button
              type="button"
              onClick={() => {

                setSelectedClinic({

                  id:
                    createdClinic?.id,

                  name:
                    createdClinic?.name,
                });

                navigate("/passport");
              }}
            >
              {tr.openPassport}
            </button>

          </div>

        </div>

      )}

      <form
        className="nizom-clinic-form"
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "700px",
        }}
      >

        <h3>
          {tr.mainData}
        </h3>

        <div>

          <label>
            {tr.clinicName}
          </label>

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          />

          {errors.name && (

            <div
              style={{
                color: "red",
                marginTop: "4px",
              }}
            >

              {errors.name[0]}

            </div>

          )}

        </div>

        <div>

          <label>
            {tr.innLabel}
          </label>

          <input
            type="text"
            name="inn"
            value={formData.inn}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          />

          {errors.inn && (

            <div
              style={{
                color: "red",
                marginTop: "4px",
              }}
            >

              {errors.inn[0]}

            </div>

          )}

        </div>

        <div>

          <label>
            {tr.registrationNumber}
          </label>

          <input
            type="text"
            name="registration_number"
            value={
              formData.registration_number
            }
            onChange={handleChange}
            disabled={isSaved}
            style={readOnlyStyle}
          />

        </div>

        <div>

          <label>
            {tr.region}
          </label>

          <select
            name="region"
            value={formData.region}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          >

            <option value="">
              {tr.selectRegion}
            </option>

            {regions.map((region) => (

              <option
                key={region.id}
                value={region.id}
              >
                {getLocalizedName(region)}
              </option>

            ))}

          </select>

        </div>

        <div>

          <label>
            {tr.district}
          </label>

          <select
            name="district"
            value={formData.district}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          >

            <option value="">
              {tr.selectDistrict}
            </option>

            {districts.map((district) => (

              <option
                key={district.id}
                value={district.id}
              >
                {getLocalizedName(district)}
              </option>

            ))}

          </select>

        </div>

        <div>

          <label>
            {tr.address}
          </label>

          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          />

        </div>

        <div>

          <label>
            Email
          </label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          />

          {errors.email && (

            <div
              style={{
                color: "red",
                marginTop: "4px",
              }}
            >

              {errors.email[0]}

            </div>

          )}

        </div>

        <div>

          <label>
            Телефон
          </label>

          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            disabled={isSaved}
            style={readOnlyStyle}
          />

        </div>

        <div>

          <label>
            {tr.status}
          </label>

          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            disabled={isSaved}
            style={readOnlyStyle}
          >

            <option value="active">
              {tr.active}
            </option>

            <option value="suspended">
              {tr.suspended}
            </option>

            <option value="closed">
              {tr.closed}
            </option>

          </select>

        </div>

        <div>

          <label>
            {tr.legalType}
          </label>

          <select
            name="legal_type"
            value={formData.legal_type}
            onChange={handleChange}
            disabled={isSaved}
            style={readOnlyStyle}
          >

            <option value="legal">
              {tr.legalEntity}
            </option>

            <option value="individual">
              {tr.individual}
            </option>

          </select>

        </div>

        <div>

          <label>
            {tr.clinicType}
          </label>

          <select
            name="clinic_type"
            value={formData.clinic_type}
            onChange={handleChange}
            disabled={isSaved}
            style={readOnlyStyle}
          >

            <option value="multidisciplinary">
              {tr.multidisciplinary}
            </option>

            <option value="specialized">
              {tr.specialized}
            </option>

            <option value="laboratory">
              {tr.laboratory}
            </option>

            <option value="functional">
              {tr.functional}
            </option>

            <option value="dentistry">
              {tr.dentistry}
            </option>

            <option value="cosmetology">
              {tr.cosmetology}
            </option>

            <option value="traditional">
              {tr.traditional}
            </option>

            <option value="other">
              {tr.other}
            </option>

          </select>

        </div>

        <h3>
          {tr.clinicUser}
        </h3>


        {isEdit && (

          <div
            style={{
              marginBottom: "16px",
            }}
          >

            {isEdit && createdClinic && (

              <div
                style={{
                  marginBottom: "12px",
                }}
              >

                <strong>{tr.login}</strong>

                {" "}

                {createdClinic.clinic_username}

              </div>

            )}


            <button
              type="button"

              onClick={
                handleResetPassword
              }

              disabled={
                resetPasswordLoading
              }
            >

              {resetPasswordLoading ? tr.resetting : tr.resetPassword}

            </button>

          </div>

        )}

        {!isEdit && (
        <>
          <div>

            <label>
              {tr.username}
            </label>

            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder={tr.autoGenerated}
              disabled={isSaved}
              style={readOnlyStyle}
            />

            <small>

              {tr.usernameHelp}

            </small>

          </div>

          <div>

            <label>
              {tr.passwordField}
            </label>

            <input
              type="text"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={tr.autoGenerated}
              disabled={isSaved}
              style={readOnlyStyle}
            />

            <small>

              {tr.passwordHelp}

            </small>

          </div>
        </>
        )}

        <button
          type="submit"
          disabled={loading || isSaved}

          style={{
            opacity: loading ? 0.7 : 1,
            cursor:
              loading
                ? "not-allowed"
                : "pointer",
          }}
        >

          {isSaved ? tr.clinicSaved : loading ? tr.saving : tr.saveClinic}
        </button>

      </form>

    </div>
  );
}
